export default "__VITE_ASSET__Dc6_6krM__"